import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  WritableSignal,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { PlanService } from 'src/app/core/services/plan.service';
import { UserService } from 'src/app/core/services/user.service';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { InvoiceModel } from 'src/app/shared/models/invoiceModel';
import {
  MemberPlanDetailModel,
  PlanDashboardTO,
} from 'src/app/shared/models/planModel';
import { UserModel } from 'src/app/shared/models/userModel';
import { MemberFinalScoreModel } from 'src/app/shared/models/member-final-score';
import { MyPlanCardComponent } from '../../shared/components/my-plan-card/my-plan-card.component';
import { ModalService } from 'src/app/core/services/modal.service';
import {
  CreditCardInfoModel,
  PaymentType,
  PaymentTypeId,
} from 'src/app/shared/models/paymentData';
import { CommonService } from 'src/app/core/services/common.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { InvoiceTableComponent } from 'src/app/shared/components/invoice-table/invoice-table.component';
import { AppModalComponent } from 'src/app/shared/components/app-modal/app-modal.component';
import {
  MemberService,
  MemberSituationEnum,
} from 'src/app/core/services/member.service';
import { PhonePipe } from 'src/app/shared/pipe/phone.pipe';
import { CepPipe } from 'src/app/shared/pipe/cep.pipe';
import { CustomCurrencyPipe } from 'src/app/shared/pipe/custom-currency.pipe';
import { MemberShipCardsDependentsModel } from 'src/app/shared/models/memberModel';
import { TermsService } from 'src/app/core/services/terms.service';
import {
  PaymentInvoiceModalComponent,
  PaymentInvoiceModalData,
} from 'src/app/shared/components/payment-invoice-modal/payment-invoice-modal.component';
import { PartnerService } from 'src/app/core/services/partner.service';
import { ExperienceService } from 'src/app/core/services/experience.service';
import { forkJoin, Subject, Subscription, takeUntil } from 'rxjs';
import { MemberFinalScoreService } from 'src/app/core/services/member-final-score.service';
import { ActiveSectionsService } from 'src/app/core/services/active-sections.service';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { SelectModel } from 'src/app/shared/components/app-select-input/app-select-input.component';
import { WaveService } from 'src/app/core/services/wave.service';
import { AppFormModalComponent } from 'src/app/shared/components/app-form-modal/app-form-modal.component';
import { FormControl } from '@angular/forms';
import { FileService } from 'src/app/core/services/file.service';
import { GameService } from 'src/app/core/services/games.service';
import { GuestService } from 'src/app/core/services/guest.service';
import { SubstituteService } from 'src/app/core/services/substitute.service';
import { CouponService } from 'src/app/core/services/coupon.service';
import { ReplaceTextPipe } from "../../shared/pipe/replace-text.pipe";
import { InvoiceService } from 'src/app/core/services/invoice.service';
import { AppChoosePaymentModalComponent } from "src/app/shared/components/app-choose-payment-modal/app-choose-payment-modal.component";
import { AppConfirmModalComponent } from "src/app/shared/components/app-confirm-modal/app-confirm-modal.component";
import { AppModalChangeCheckinComponent } from "src/app/shared/components/app-modal-change-checkin/app-modal-change-checkin.component";

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    AppButtonComponent,
    CommonModule,
    CustomCurrencyPipe,
    MatIconModule,
    MyPlanCardComponent,
    InvoiceTableComponent,
    PaymentInvoiceModalComponent,
    PhonePipe,
    AppModalComponent,
    AppFormModalComponent,
    ReplaceTextPipe,
    AppChoosePaymentModalComponent,
    AppConfirmModalComponent,
    AppModalChangeCheckinComponent
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();

  heightLastInvoice = 0;
  user: UserModel;
  memberFinalScore: MemberFinalScoreModel;
  pattern: any;
  lastInvoice: any;
  plan: PlanDashboardTO;
  cepPipe = new CepPipe();
  memberShipCard: MemberShipCardsDependentsModel | null;
  memberSeatNumber: any;
  memberPlanId: any;
  isBenefitsActive: boolean = false;
  isActiveRanking: boolean = false;
  isActiveExperiences: boolean = false;
  isActiveCheckins: boolean = false;
  isAtLeast12: boolean = true;
  isSenior: boolean = false;
  modalId = 'payment-modal-dashboard';
  orderModalId = 'orderModal';
  PaymentType = PaymentType;
  paymentType: PaymentType;
  paymentInvoiceModalData: PaymentInvoiceModalData;
  showDashboard = false;
  canChekPix = true;
  showContinuousMonth = localStorage.getItem('showContinuousMonth') === 'true';
  isSecondaryPlan: boolean = localStorage.getItem('isSecondaryPlan') === 'true';
  public styles: { [key: string]: string };
  carteirinhaImg = localStorage.getItem('imageLogo');
  virtualCard = localStorage.getItem('virtualCard');
  isForeigner = false;
  teamName = localStorage.getItem('clubName');

  btnUpgradeOptions = {
    buttonText: 'Fazer Upgrade',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm fs-small px-5 btn-primary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000',
    fontSize: 12,
  };

  btnInvoiceDetailsOptions = {
    buttonText: 'Detalhar Fatura',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm btn-primary fs-xsmall',
    fontSize: 12,
  };

  btnUpdateDataOptions = {
    buttonText: 'Atualizar Dados',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm fs-xsmall btn-primary',
    fontSize: 12,
  };

  btnRankDetailsOptions = {
    buttonText: 'Mais detalhes',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm fs-xsmall btn-primary',
    fontSize: 12,
  };

  btnExperienceOptions = {
    buttonText: 'Ver mais experiências',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm fs-xsmall btn-primary',
    fontSize: 12,
  };

  btnGuessesOptions = {
    buttonText: 'Ver palpites',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm fs-xsmall btn-primary',
    fontSize: 12,
  };

  btnPartnershipsCouponsOptions = {
    buttonText: 'Ver todos os cupons',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm fs-xsmall btn-primary',
    fontSize: 12,
  };

  btnRescueOptions = {
    buttonText: 'Resgatar',
    borderRadius: '25px',
    buttonSize: 'btn fs-xsmall px-2 py-1 btn-primary',
    fontSize: 12,
  };

  checkinButtonOptions = {
    buttonText: 'Realizar Check-in',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm btn-primary fs-xsmall',
    fontSize: 12,
  };

  invoiceList: any[];
  invoice: InvoiceModel;

  //card checkin
  showDiv = false;
  ingressosCheckIn: any[] = [];
  nextGame: any[] = [];
  checkinsHistory: any = [];
  limitCheckin: any;
  checkinSelected: any;
  selectInputOptionsModal: SelectModel[] = [];
  memberDependents: any;
  selectControlModal: FormControl = new FormControl();
  teamLogo: string = '';
  guestSelect: any;
  substituteSelect: any;
  linkModalConfirm: string = '';
  pendentTicket: any;
  showIndicators: boolean = false;
  paymentModalData: any;
  isPixParcelado = false;

  orderModalBodyMessage =
    'Você já possui um pedido de plano em andamento. Deseja continuar com o pedido ou cancelar?';
  termsModalBodyMessage: string = '';
  updateMemberModalBodyMessage: string = '';

  creditCardInfo: WritableSignal<CreditCardInfoModel[]> = signal([]);
  partners: any;
  experiences: any[] = [];
  gameList: any[] = [];
  secondaryPlanId = JSON.parse(
    localStorage.getItem('secondaryPlanDetail') as string
  )?.planId;

  width!: any;

  resizeSubscription!: Subscription;
  isCeara = this.authService.isCeara;

  constructor(
    private userService: UserService,
    private planService: PlanService,
    private memberFinalScoreService: MemberFinalScoreService,
    private router: Router,
    private couponService: CouponService,
    private partnerService: PartnerService,
    private termsService: TermsService,
    private modalService: ModalService,
    private memberService: MemberService,
    public commonService: CommonService,
    private activeSectionsService: ActiveSectionsService,
    private experienceService: ExperienceService,
    private alertService: AlertService,
    private waveService: WaveService,
    private cdr: ChangeDetectorRef,
    private fileService: FileService,
    private gameService: GameService,
    private guestService: GuestService,
    private substituteService: SubstituteService,
    private invoiceService: InvoiceService,
    private authService: AuthService
  ) {
    this.user = this.userService.currentUserValue as UserModel;
    this.isForeigner = this.user?.isForeigner || false;

    if (this.isCeara) {
      this.btnPartnershipsCouponsOptions.buttonText = 'Acessar Club de Vantagens';
    }
  }

  ngOnInit(): void {
    this.styles = {
      '--primaryColor': localStorage.getItem('primaryColor') as string,
      '--membership-card-size': localStorage.getItem('membershipCardSize') as string + 'rem'
    };
    const stringContinuousMonth = localStorage.getItem(
      'showContinuousMonth'
    ) as string;
    this.showContinuousMonth = stringContinuousMonth === 'true';

    this.getActiveSections();

    // Verificar se os dados do usuário estão completos
    this.checkUserData();
  }

  private checkUserData(): void {
    const hasIncompleteData =
      !this.user?.addresses?.length ||
      !this.user?.emails?.length ||
      !this.user?.birthDate;

    if (hasIncompleteData) {
      this.showModalpdateDataModal()
    } else {
      this.getMemberPublicInfo();
    }
  }

  onUpdateDataModalConfirm(): void {
    this.router.navigate(['/dados-de-socio']);
  }

  ngAfterViewInit(): void {

    this.getLogo();
  }

  // card checkin

  getAdversaryLogo(ingresso: any) {
    return this.fileService.getDocDownloadUrl(
      ingresso.waveGame.adversary.document.id
    );
  }

  getAdversaryLogo2(ingresso: any) {
    return this.fileService.getDocDownloadUrl(ingresso.adversary.document.id);
  }

  getLogo() {
    this.gameService.getNextMatches().subscribe({
      next: (response: any) => {
        let nextMatchesResponse = response;
        this.teamLogo = this.commonService.getImageStr(
          nextMatchesResponse.logo.id
        );
      },
      error: (error) => {
        console.error('Error: ', error);
      },
    });
  }

  async openCheckInModal(event: any): Promise<void> {
    const wave = this.ingressosCheckIn.find(w => w.id === event);
    if (this.user.allowCheckin === false) {
      if ((!wave.isAvaliableNoDocsMinors && !this.isAtLeast12) || (!wave.isAvaliableNoDocsSeniors && this.isSenior) || (!this.isSenior && this.isAtLeast12 && this.user.allowCheckin === false)) {
        this.alertService.showAlert(
          AlertType.WARNING,
          'Você está com pendência de documentos ou com check-in bloqueado. Entre em contato com a equipe de atendimento.'
        );
        return;
      }
    }

    try {
      this.checkinsHistory = await this.waveService
        .getCheckinsRealizados(event, this.user.id)
        .toPromise();
      this.limitCheckin = await this.waveService
        .getLimitByMemberPlan(this.plan.id)
        .toPromise();
    } catch (error) {
      console.error('Error:', error);
    }
    this.checkinSelected = event;
    this.modalService.open('modalCheckinTicket');
  }

  onModalFormConfirm(event: any) {
    if (event.isDependent) {
      const dependentSelect = this.memberDependents.content.find((i: any) => i.id === event.clientSelected);

      const missingFields = this.validDependent(dependentSelect);
      if (missingFields.length > 0) {
        this.alertService.showAlert(
          AlertType.WARNING,
          `Dependente com dados incompletos. Campos obrigatórios não preenchidos: ${missingFields}.`
        );
        return;
      }
    }

    if (event.isSubstitute && event.substituteData && event.substituteTax) {
      this.invoiceService.createSubstituteTaxInvoice(this.plan.id, event.substituteTax.id).subscribe({
        next: (res) => {
          if (res.invoicePaymentStatus !== '7859ffd3-9390-4d25-89a6-8f27533bb37e') { // Pago
            setTimeout(() => {
              this.paymentModalData = { invoice: res, checkin: event };
              this.modalService.open('modalChoosePayment');
            }, 400);
          } else {
            this.onModalCheckinConfirm(event);
          }
        },
        error: (error) => {
          console.error('Error:', error);
          this.alertService.showAlert(
            AlertType.WARNING,
            `Não foi possível gerar a fatura da taxa de substituição. Tente novamente.`
          );
        }
      });
    } else if (!event.isSubstitute && !event.substituteData && event.checkinTax) {
      this.invoiceService.createCheckinTaxInvoice(this.plan.id, event.checkinTax.id).subscribe({
        next: (res) => {
          if (res.invoicePaymentStatus !== '7859ffd3-9390-4d25-89a6-8f27533bb37e') { // Pago
            setTimeout(() => {
              this.paymentModalData = { invoice: res, checkin: event };
              this.modalService.open('modalChoosePayment');
            }, 400);
          } else {
            this.onModalCheckinConfirm(event);
          }
        },
        error: (error) => {
          console.error('Error:', error);
          this.alertService.showAlert(
            AlertType.WARNING,
            `Não foi possível gerar a fatura da taxa de substituição. Tente novamente.`
          );
        }
      });
    }
    else {
      this.onModalCheckinConfirm(event);
    }
  }

  async onModalCheckinConfirm(event: any): Promise<void> {
    const waveSelect = this.ingressosCheckIn.find((i: any) => i.id === this.checkinSelected);

    let dependentSelect: any;
    if (event.isDependent) {
      dependentSelect = this.memberDependents.content.find((i: any) => i.id === event.clientSelected);
    }

    if (event.isGuest && event.guestData) {
      let guestPayload: any = {
        id: event.guestData.idControl ? event.guestData.idControl : '',
        name: event.guestData.nameControl,
        cpf: event.guestData.cpfControl,
        email: event.guestData.emailControl,
      };

      try {
        this.guestSelect = await this.guestService
          .createGuestCheckin(guestPayload)
          .toPromise();
      } catch (error) {
        console.error('Error:', error);
      }
    }

    if (event.isSubstitute && event.substituteData) {
      let substitutePayload: any = {
        id: event.substituteData.idControl
          ? event.substituteData.idControl
          : '',
        name: event.substituteData.nameControl,
        cpf: event.substituteData.cpfControl,
        email: event.substituteData.emailControl,
      };

      try {
        this.substituteSelect = await this.substituteService
          .createSubstituteCheckin(substitutePayload)
          .toPromise();
      } catch (error) {
        console.error('Error:', error);
      }
    }

    if (waveSelect?.waveGame?.ticketsApiType?.id === '2649821c-02d2-407e-9cf5-0a1741a9ec37') {
      this.waveService.verifyFacialStatusImply(event.isDependent
        ? dependentSelect?.cpf
        : event.isGuest
          ? event.guestData.cpfControl
          : event.isSubstitute
            ? event.substituteData.cpfControl
            : this.pattern?.cpf).subscribe({
              next: (res: any) => {
                if (res.error == null && res.result.code === 20000) {

                  let checkinImplyPayload: any = {
                    memberId: this.pattern.id,
                    memberName: event.isDependent
                      ? dependentSelect?.name
                      : event.isGuest
                        ? event.guestData.nameControl
                        : event.isSubstitute
                          ? event.substituteData.nameControl
                          : this.pattern?.name,
                    memberDocument: event.isDependent
                      ? dependentSelect?.cpf
                      : event.isGuest
                        ? event.guestData.cpfControl
                        : event.isSubstitute
                          ? event.substituteData.cpfControl
                          : this.pattern?.cpf,
                    eventId: waveSelect.waveGame.event,
                    ticketId: event.ticketSelected,
                    code: event.isDependent
                      ? dependentSelect?.membershipCard?.cardNumber
                      : event.isGuest
                        ? '1' + event.guestData.cpfControl
                        : event.isSubstitute
                          ? '1' + event.substituteData.cpfControl
                          : this.memberShipCard?.cardNumber
                  }

                  let isUpdate = this.validIsUpdate(event, this?.checkinsHistory);

                  if (isUpdate) {

                    let jaExiste = this.validJaExiste(event, this?.checkinsHistory);

                    if (jaExiste) {
                      this.alertService.showAlert(
                        AlertType.WARNING,
                        `Já existe um checkin gerado para este usuário nesse jogo!`
                      );
                    } else {
                      this.waveService.updateCheckinImply(checkinImplyPayload).subscribe({
                        next: (res: any) => {
                          if (res.error != null) {
                            if (res.error.code === 20006) {
                              this.alertService.showAlert(
                                AlertType.WARNING,
                                `Já existe um checkin gerado para este usuário!`
                              );
                            } else {
                              console.error('Error: ', res.error);
                              this.alertService.showAlert(
                                AlertType.WARNING,
                                `Não foi possível realizar o checkin, tente novamente mais tarde!`
                              );
                            }
                          } else {
                            let parsed = JSON.parse(res.result);
                            let orderId = parsed.key;
                            let checkinPayload: any = {
                              waveId: this.checkinSelected,
                              ticketId: event.isDependent
                                ? waveSelect.waveTicketsDependent.find(
                                  (i: any) => i.ticketId === event.ticketSelected
                                ).id
                                : event.isGuest
                                  ? waveSelect.waveTicketsGuest.find(
                                    (i: any) => i.ticketId === event.ticketSelected
                                  ).id
                                  : waveSelect.waveTicketsSocio.find(
                                    (i: any) => i.ticketId === event.ticketSelected
                                  ).id,
                              memberPlanId: this.plan.id,
                              memberDependentId: event.isDependent ? event.clientSelected : '',
                              guestCheckinId: event.isGuest ? this.guestSelect?.id : '',
                              substituteCheckinId: event.isSubstitute
                                ? this.substituteSelect?.id
                                : '',
                              ticketLink: window.location.origin + '/check-in/detalhe/' + orderId,
                              ticketValue: event.isDependent
                                ? waveSelect.waveTicketsDependent.find(
                                  (i: any) => i.ticketId === event.ticketSelected
                                ).ticketValue
                                : event.isGuest
                                  ? waveSelect.waveTicketsGuest.find(
                                    (i: any) => i.ticketId === event.ticketSelected
                                  ).ticketValue
                                  : waveSelect.waveTicketsSocio.find(
                                    (i: any) => i.ticketId === event.ticketSelected
                                  ).ticketValue,
                              ticketCode: event.isDependent
                                ? dependentSelect?.membershipCard?.cardNumber
                                : event.isGuest
                                  ? '1' + event.guestData.cpfControl
                                  : event.isSubstitute
                                    ? '1' + event.substituteData.cpfControl
                                    : this.memberShipCard?.cardNumber,
                              orderId: orderId,
                              checkinTaxId: event?.checkinTax?.id || null
                            };

                            this.waveService.criarCheckin(checkinPayload).subscribe((data) => {
                              this.alertService.showAlert(
                                AlertType.SUCCESS,
                                'Checkin realizado com sucesso.'
                              );
                              // const newTab = window.open('', '_blank');
                              // if (newTab) {
                              //   newTab.location.href = res.link;
                              // } else {
                              //   window.location.href = res.link;
                              // }
                              window.location.reload();
                            });

                          }
                        }, error: (error) => {
                          console.error('Error: ', error);
                        },
                      })
                    }
                  } else {
                    this.waveService.realizarCheckinImply(checkinImplyPayload).subscribe({
                      next: (res: any) => {
                        if (res.error != null) {
                          if (res.error.code === 20006) {
                            this.alertService.showAlert(
                              AlertType.WARNING,
                              `Já existe um checkin gerado para este usuário!`
                            );
                          } else {
                            console.error('Error: ', res.error);
                            this.alertService.showAlert(
                              AlertType.WARNING,
                              `Não foi possível realizar o checkin, tente novamente mais tarde!`
                            );
                          }
                        } else {
                          let parsed = JSON.parse(res.result);
                          let orderId = parsed.key;
                          let checkinPayload: any = {
                            waveId: this.checkinSelected,
                            ticketId: event.isDependent
                              ? waveSelect.waveTicketsDependent.find(
                                (i: any) => i.ticketId === event.ticketSelected
                              ).id
                              : event.isGuest
                                ? waveSelect.waveTicketsGuest.find(
                                  (i: any) => i.ticketId === event.ticketSelected
                                ).id
                                : waveSelect.waveTicketsSocio.find(
                                  (i: any) => i.ticketId === event.ticketSelected
                                ).id,
                            memberPlanId: this.plan.id,
                            memberDependentId: event.isDependent ? event.clientSelected : '',
                            guestCheckinId: event.isGuest ? this.guestSelect?.id : '',
                            substituteCheckinId: event.isSubstitute
                              ? this.substituteSelect?.id
                              : '',
                            ticketLink: window.location.origin + '/check-in/detalhe/' + orderId,
                            ticketValue: event.isDependent
                              ? waveSelect.waveTicketsDependent.find(
                                (i: any) => i.ticketId === event.ticketSelected
                              ).ticketValue
                              : event.isGuest
                                ? waveSelect.waveTicketsGuest.find(
                                  (i: any) => i.ticketId === event.ticketSelected
                                ).ticketValue
                                : waveSelect.waveTicketsSocio.find(
                                  (i: any) => i.ticketId === event.ticketSelected
                                ).ticketValue,
                            ticketCode: event.isDependent
                              ? dependentSelect?.membershipCard?.cardNumber
                              : event.isGuest
                                ? '1' + event.guestData.cpfControl
                                : event.isSubstitute
                                  ? '1' + event.substituteData.cpfControl
                                  : this.memberShipCard?.cardNumber,
                            orderId: orderId,
                            checkinTaxId: event?.checkinTax?.id || null
                          };

                          this.waveService.criarCheckin(checkinPayload).subscribe((data) => {
                            this.alertService.showAlert(
                              AlertType.SUCCESS,
                              'Checkin realizado com sucesso.'
                            );
                            // const newTab = window.open('', '_blank');
                            // if (newTab) {
                            //   newTab.location.href = res.link;
                            // } else {
                            //   window.location.href = res.link;
                            // }
                            window.location.reload();
                          });

                        }
                      }, error: (error) => {
                        console.error('Error: ', error);
                      },
                    })
                  }
                } else if (res.error == null && res.result.code === 20002) {
                  this.alertService.showAlert(
                    AlertType.INFO,
                    `Seu cadastro de Facial está em análise, aguarde alguns instantes até que seja validado e tente novamente mais tarde`
                  );
                } else {
                  this.alertService.showAlert(
                    AlertType.INFO,
                    `Status da Facial: ${res.error != null ? 'Facial não cadastrada' : res.result?.msg}. Você será redirecionado para realizar a validação facial!`
                  );

                  let setPessoaPayload: any = {
                    de_para: event.isDependent
                      ? dependentSelect?.cpf
                      : event.isGuest
                        ? event.guestData.cpfControl
                        : event.isSubstitute
                          ? event.substituteData.cpfControl
                          : this.pattern?.cpf,
                    nome: event.isDependent
                      ? dependentSelect?.name
                      : event.isGuest
                        ? event.guestData.nameControl
                        : event.isSubstitute
                          ? event.substituteData.nameControl
                          : this.pattern?.name,
                    cpf: event.isDependent
                      ? dependentSelect?.cpf
                      : event.isGuest
                        ? event.guestData.cpfControl
                        : event.isSubstitute
                          ? event.substituteData.cpfControl
                          : this.pattern?.cpf,
                    email: event.isDependent
                      ? event.emailDependent ? event.emailDependent : dependentSelect?.email
                      : event.isGuest
                        ? event.guestData.emailControl
                        : event.isSubstitute
                          ? event.substituteData.emailControl
                          : this.pattern?.emails[0]?.email,
                    dt_nascimento: event.isDependent ? dependentSelect?.birthDate : this.pattern?.birthDate,
                    informacoes_extras: {
                      redirect_url: window.location.href
                    }
                  }

                  this.waveService.registerFacialImply(setPessoaPayload).subscribe({
                    next: (res: any) => {
                      if (res.error != null) {
                        this.alertService.showAlert(
                          AlertType.WARNING,
                          `Não foi possível cadastrar a facial, tente novamente mais tarde!`
                        );
                      } else {
                        let token = res.result;
                        let urlFacial = `https://ahmangueirao.eleventickets.com/OAuth2/external?token=${token}&url=aHR0cHM6Ly9haG1hbmd1ZWlyYW8uZWxldmVudGlja2V0cy5jb20vRmFjaWFsUmVjb2duaXRpb24%3D`;
                        window.location.href = urlFacial;
                      }
                    }, error: (error) => {
                      console.error('Error: ', error);
                    },
                  })

                }

              }, error: (error) => {
                console.error('Error: ', error);
              },
            });
    } else {
      let ticketPayload: any = {
        customer: {
          name: event.isDependent
            ? dependentSelect?.name
            : event.isGuest
              ? event.guestData.nameControl
              : event.isSubstitute
                ? event.substituteData.nameControl
                : this.pattern?.name,
          doc: event.isDependent
            ? dependentSelect?.cpf
            : event.isGuest
              ? event.guestData.cpfControl
              : event.isSubstitute
                ? event.substituteData.cpfControl
                : this.pattern?.cpf,
          email: event.isDependent
            ? event.emailDependent ? event.emailDependent : dependentSelect?.email
            : event.isGuest
              ? event.guestData.emailControl
              : event.isSubstitute
                ? event.substituteData.emailControl
                : this.pattern?.emails[0]?.email,
          mifare: event.isDependent
            ? dependentSelect?.membershipCard?.cardNumber
              ? dependentSelect?.membershipCard?.cardNumber
              : ''
            : `1${this.pattern.cpf}`,
          phones: [event.isDependent && dependentSelect?.phone ? dependentSelect?.phone : this.pattern?.phones[0]?.number],
          birthDate: event.isDependent ? dependentSelect?.birthDate : this.pattern?.birthDate
        },
        tickets: [
          {
            ticketId: event.ticketSelected,
            ticketValue: event.isDependent
              ? waveSelect.waveTicketsDependent.find(
                (i: any) => i.ticketId === event.ticketSelected
              )?.ticketValue
              : event.isGuest
                ? waveSelect.waveTicketsGuest.find(
                  (i: any) => i.ticketId === event.ticketSelected
                )?.ticketValue
                : event.isSubstitute
                  ? waveSelect.waveTicketsSocio.find(
                    (i: any) => i.ticketId === event.ticketSelected
                  )?.ticketValue
                  : this.isSenior && waveSelect.waveTicketsSeniors?.length > 0
                    ? waveSelect.waveTicketsSeniors.find(
                      (i: any) => i.ticketId === event.ticketSelected
                    )?.ticketValue
                    : this.isAtLeast12 && waveSelect.waveTicketsMinors?.length > 0
                      ? waveSelect.waveTicketsMinors.find(
                        (i: any) => i.ticketId === event.ticketSelected
                      )?.ticketValue
                      : waveSelect.waveTicketsSocio.find(
                        (i: any) => i.ticketId === event.ticketSelected
                      )?.ticketValue ?? 0, // Fallback para 0 caso o valor não seja encontrado
            customer: {
              name: event.isDependent
                ? dependentSelect?.name
                : event.isGuest
                  ? event.guestData.nameControl
                  : event.isSubstitute
                    ? event.substituteData.nameControl
                    : this.pattern?.name,
              doc: event.isDependent
                ? dependentSelect?.cpf
                : event.isGuest
                  ? event.guestData.cpfControl
                  : event.isSubstitute
                    ? event.substituteData.cpfControl
                    : this.pattern?.cpf,
              email: event.isDependent
                ? event.emailDependent ? event.emailDependent : dependentSelect?.email
                : event.isGuest
                  ? event.guestData.emailControl
                  : event.isSubstitute
                    ? event.substituteData.emailControl
                    : this.pattern?.emails[0]?.email,
              mifare: event.isDependent
                ? dependentSelect?.membershipCard?.cardNumber
                  ? dependentSelect?.membershipCard?.cardNumber
                  : ''
                : `1${this.pattern.cpf}`,
              phones: [event.isDependent && dependentSelect?.phone ? dependentSelect?.phone : this.pattern?.phones[0]?.number],
            },
          },
        ],
      };

      this.waveService.realizarCheckin(ticketPayload).subscribe({
        next: (res: any) => {
          if (res?.mandatoryFace && event?.isGuest) {
            this.linkModalConfirm = res?.link;
            this.modalService.open('modalConfirm');
          }

          if (res.orderStatus && res?.orderStatus === 'Initial') {
            this.pendentTicket = res;
            this.modalService.open('modalChangeCheckin');
          } else if (res?.mandatoryFace) {
            const newTab = window.open('', '_blank');
            if (newTab) {
              newTab.location.href = res?.link; // Define a URL da aba já aberta
            } else {
              window.location.href = res.link;
            }
          } else {
            let checkinPayload: any = {
              waveId: this.checkinSelected,
              ticketId: event.isDependent
                ? waveSelect.waveTicketsDependent.find(
                  (i: any) => i.ticketId === event.ticketSelected
                )?.id
                : event.isGuest
                  ? waveSelect.waveTicketsGuest.find(
                    (i: any) => i.ticketId === event.ticketSelected
                  )?.id
                  : event.isSubstitute
                    ? waveSelect.waveTicketsSocio.find(
                      (i: any) => i.ticketId === event.ticketSelected
                    )?.id
                    : this.isSenior && waveSelect.waveTicketsSeniors?.length > 0
                      ? waveSelect.waveTicketsSeniors.find(
                        (i: any) => i.ticketId === event.ticketSelected
                      )?.id
                      : !this.isAtLeast12 && waveSelect.waveTicketsMinors?.length > 0
                        ? waveSelect.waveTicketsMinors.find(
                          (i: any) => i.ticketId === event.ticketSelected
                        )?.id
                        : waveSelect.waveTicketsSocio.find(
                          (i: any) => i.ticketId === event.ticketSelected
                        )?.id,
              memberPlanId: this.plan.id,
              memberDependentId: event.isDependent ? event.clientSelected : '',
              guestCheckinId: event.isGuest ? this.guestSelect?.id : '',
              substituteCheckinId: event.isSubstitute
                ? this.substituteSelect?.id
                : '',
              ticketLink: res?.link || '',
              ticketValue: event.isDependent
                ? waveSelect.waveTicketsDependent.find(
                  (i: any) => i.ticketId === event.ticketSelected
                )?.ticketValue
                : event.isGuest
                  ? waveSelect.waveTicketsGuest.find(
                    (i: any) => i.ticketId === event.ticketSelected
                  )?.ticketValue
                  : event.isSubstitute
                    ? waveSelect.waveTicketsSocio.find(
                      (i: any) => i.ticketId === event.ticketSelected
                    )?.ticketValue
                    : this.isSenior && waveSelect.waveTicketsSeniors?.length > 0
                      ? waveSelect.waveTicketsSeniors.find(
                        (i: any) => i.ticketId === event.ticketSelected
                      )?.ticketValue
                      : this.isAtLeast12 && waveSelect.waveTicketsMinors?.length > 0
                        ? waveSelect.waveTicketsMinors.find(
                          (i: any) => i.ticketId === event.ticketSelected
                        )?.ticketValue
                        : waveSelect.waveTicketsSocio.find(
                          (i: any) => i.ticketId === event.ticketSelected
                        )?.ticketValue,
              ticketCode: res?.codes[0] || '',
              orderId: res.orderId,
              checkinTaxId: event?.checkinTax?.id || null
            };
            this.waveService.criarCheckin(checkinPayload).subscribe((data) => {
              this.alertService.showAlert(
                AlertType.SUCCESS,
                'Checkin realizado com sucesso.'
              );
              const newTab = window.open('', '_blank');
              if (newTab) {
                newTab.location.href = res.link;
              } else {
                window.location.href = res.link;
              }
              window.location.reload();
            });
          }
        },
        error: (error) => {
          console.error('Error: ', error);
        },
      });
    }
  }

  validJaExiste(event: any, history: any) {
    if (!history) {
      return false;
    } else if (event.isGuest && history.find((i: any) => i.memberGuestId != null && i.checkinStatus == 'Realizado')) {
      return true;
    } else if (event.isDependent && history.find((i: any) => i.memberDependentId != null && i.checkinStatus == 'Realizado')) {
      return true;
    } else if (event.isSubstitute && history.find((i: any) => i.memberSubstituteId != null && i.checkinStatus == 'Realizado')) {
      return true;
    } else if (!event.isGuest && !event.isSubstitute && !event.isDependent &&
      history.find((i: any) => i.memberPlanId != null && !i.isDependent && !i.isGuest && !i.isSubstitute && i.checkinStatus == 'Realizado')) {
      return true;
    } else {
      return false;
    }
  }

  validIsUpdate(event: any, history: any) {
    if (!history) {
      return false;
    } else if (event.isGuest && history.find((i: any) => i.memberGuestId != null && i.checkinStatus == 'Cancelado')) {
      return true;
    } else if (event.isDependent && history.find((i: any) => i.memberDependentId != null && i.checkinStatus == 'Cancelado')) {
      return true;
    } else if (event.isSubstitute && history.find((i: any) => i.memberSubstituteId != null && i.checkinStatus == 'Cancelado')) {
      return true;
    } else if (!event.isGuest && !event.isSubstitute && !event.isDependent &&
      history.find((i: any) => i.memberPlanId != null && !i.isDependent && !i.isGuest && !i.isSubstitute && i.checkinStatus == 'Cancelado')) {
      return true;
    } else {
      return false;
    }
  }

  validDependent(dependent: any): string {
    const missingFields = [];

    if (!dependent?.name) {
      missingFields.push('Nome');
    }
    if (!dependent?.cpf) {
      missingFields.push('CPF');
    }
    if (!dependent?.email) {
      missingFields.push('E-mail');
    }
    if (!dependent?.membershipCard?.cardNumber) {
      missingFields.push('Carteirinha');
    }
    if (!dependent?.birthDate) {
      missingFields.push('Data de Nascimento');
    }

    return missingFields.join(', ');
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  getMemberPublicInfo() {
    this.memberService.getMemberPublicInfo().pipe(takeUntil(this._destroy$)).subscribe((res) => {
      this.user = res;
      if (this.user?.termsAccepted == false) {
        this.showTermsModal();
      } else {
        // Verifica se o socio possui plano ou tem situação bloqueada
        if (
          !this.secondaryPlanId &&
          (this.user?.memberPlans?.length == 0 ||
            this.memberService.isMemberSituationInEnum(
              this.user?.memberSituation?.id as string
            ))
        ) {
          if (
            this.user?.memberSituation?.id === MemberSituationEnum.NaoRenovado
          ) {
            this.planService.getLastExpiredMemberPlan(this.user.id).subscribe({
              next: (res: MemberPlanDetailModel) => {
                const lastExpiredPlan = res;
                if (lastExpiredPlan?.planEndDate) {
                  const planEndDate = new Date(lastExpiredPlan?.planEndDate);
                  const today = new Date();
                  if (
                    planEndDate.getMonth() === today.getMonth() &&
                    planEndDate.getFullYear() === today.getFullYear()
                  ) {
                    this.router.navigate(['/renovar-plano'], {
                      queryParams: { newAdesion: false },
                    });
                  } else {
                    this.router.navigate(['/selecionar-plano']);
                  }
                } else {
                  this.router.navigate(['/selecionar-plano']);
                }
              },
              error: (error: any) => {
                console.error('Error: ', error);
                this.router.navigate(['/selecionar-plano']);
              },
            });
          } else {
            this.router.navigate(['/selecionar-plano']);
          }
        } else {
          this.getPartners();
          this.getMemberFinalScore();

          if (this.user?.memberPlans?.length == 0) return;
          this.getMemberDashboardData();

          //this.getMemberPlanDashboardData();
          const creditCardArr =
            this.commonService.getCreditCardInfoFromLocalStorage();
          this.creditCardInfo.set(creditCardArr);
        }
      }
    });
  }

  getMemberPlanDashboardData() {
    this.memberService
      .getMemberPlanDashboardData(this.user.id, this.isSecondaryPlan)
      .subscribe({
        next: (res) => {
          this.plan = res;
          this.memberPlanId = res.id;
          if (this.plan) {
            this.isPixParcelado = this.plan.paymentMethodTypeId === PaymentTypeId.PIX_PARCELADO;
            this.getNextActivesWaves();
            this.getMembeInvoiceDashboardData();
            this.getLastMembeInvoiceDashboardData();
            this.getMemberShipCardDashboardData();
            this.getMemberSeatNumberDashboardData();
            this.getExperiences();
          }
          this.showDashboard = true;
          this.cdr.detectChanges();

          if (this.pattern.id && this.plan.id) {
            this.getMemberDependentesByMember();
          }
        },
        error: (e) => {
          console.error('Error:', e);
          this.alertService.showAlert(AlertType.WARNING, e.error.message);
        },
      });
  }

  getMembeInvoiceDashboardData() {
    this.memberService
      .getMembeInvoiceDashboardData(this.plan.id)
      .subscribe((invoices) => {
        invoices.forEach((invoice) => {
          // Mantém os valores nulos se refMonth ou refYear forem nulos
          const refMonth = invoice.refMonth !== null ? invoice.refMonth : null;
          const refYear = invoice.refYear !== null ? invoice.refYear : null;
          invoice.referenceMonthSort =
            refYear !== null && refMonth !== null
              ? new Date(parseInt(refYear), parseInt(refMonth) - 1)
              : null;
          invoice.refMonth =
            refMonth !== null ? refMonth.toString().padStart(2, '0') : null;
          let discount = invoice.discount || 0;
          discount = discount > invoice.amount ? 0 : discount;
          invoice.amount -= discount;
        });
        invoices.sort((a, b) => {
          if (a.referenceMonthSort && b.referenceMonthSort) {
            return (
              new Date(b.referenceMonthSort).getTime() -
              new Date(a.referenceMonthSort).getTime()
            );
          }
          return 0;
        });
        this.invoiceList = invoices;
      });
  }

  getLastMembeInvoiceDashboardData() {
    this.memberService
      .getLastMembeInvoiceDashboardData(this.plan.id)
      .subscribe((lastInvoices) => {
        let discount = lastInvoices.discount || 0;
        discount = discount > lastInvoices.amount ? 0 : discount;
        this.lastInvoice = { ...lastInvoices, amount: lastInvoices.amount - discount };
      });
  }

  getNextActivesWaves() {
    this.waveService.getNextActivesWaves(this.plan?.plan?.id).subscribe(
      (data) => {
        if (data.length > 0) {
          this.ingressosCheckIn = data;
          this.showIndicators = this.ingressosCheckIn.length > 1;
        } else {
          this.waveService.getNextGame().subscribe((res) => {
            if (res?.length > 0) {
              this.nextGame = res;
              this.showIndicators = this.nextGame.length > 1;
            }
          });
        }
      },
      (error) => {
        this.waveService.getNextGame().subscribe((res) => {
          if (res.length > 0) {
            this.nextGame = res;
            this.showIndicators = this.nextGame.length > 1;
          }
        });
      }
    );
  }

  getMemberDependentesByMember() {
    this.memberService
      .getMemberDependentesByMember(this.pattern.id, this.plan.id)
      .subscribe((data) => {
        this.memberDependents = data;
        data.content.forEach((dep) => {
          let optionDep: SelectModel = {
            code: dep.id,
            name: `${dep.name} (Dependente)`,
          };
          this.selectInputOptionsModal.push(optionDep);
        });
      });
  }

  getMemberShipCardDashboardData() {
    if (this.memberPlanId) {
      this.memberService
        .getMemberShipCardDashboardData(this.user.id, this.memberPlanId)
        .subscribe((res) => {
          this.memberShipCard = { ...res, src: this.commonService.getImageStr(res.imgPortalPlanId) };
        });
    }
  }

  getMemberSeatNumberDashboardData() {
    if (this.memberPlanId) {
      this.memberService
        .getMemberSeatNumberDashboardData(this.user.id, this.memberPlanId)
        .subscribe((res) => {
          this.memberSeatNumber = {
            ...res,
            seatNumber: res.seatNumber[0] + '-' + res.seatNumber.slice(1),
            planName: this.plan.plan.planName
          };
        });
    }
  }

  getMemberDashboardData() {
    this.memberService.getMemberDashboardData(this.user.id).subscribe((res) => {
      this.pattern = res;

      if (res.birthDate) {
        const birth = new Date(res.birthDate);
        const now = new Date();
        let age = now.getFullYear() - birth.getFullYear();
        const m = now.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
          age--;
        }
        this.isAtLeast12 = age >= 12;
        this.isSenior = age >= 65;
      }

      let option: SelectModel = {
        code: res.id,
        name: `${res.name} (Sócio)`,
      };
      this.selectInputOptionsModal.push(option);
      if (this.pattern) {
        this.getMemberPlanDashboardData();
      }
    });
  }

  showOptionsPayment(): boolean {
    switch (this.lastInvoice?.invoicePaymentStatus?.statusTypeName) {
      case 'Aberto':
        return true;
        break;
      case 'Vencido':
        return true;
        break;
      case 'Rejeitado':
        return true;
        break;
      case 'Não Autorizado':
        return true;
        break;
      /* case 'Cancelado':
        return true
        break; */
      default:
        return false;
        break;
    }
  }

  getExperiences() {
    if (this.plan?.plan?.id) {
      this.experienceService.getExperiencesByPlan(this.plan.plan.id).subscribe((res: any[]) => {
        this.experiences = res.slice(0, 3);
        this.experiences.forEach((experience: any) => {
          experience.src = this.commonService.getImageStr(experience.document.id);
        });

        if (this.experiences.length < 3) {
          this.getAllGames(3 - this.experiences.length);
        }
      });
    }
  }

  getAllGames(count: number) {
    this.gameService.getAllGames().subscribe((data) => {
      this.gameList = data.content
        .sort((a, b) => {
          const dateA = new Date(`${a.gameDate}T${a.gameTime}`);
          const dateB = new Date(`${b.gameDate}T${b.gameTime}`);
          return dateB.getTime() - dateA.getTime();
        })
        .map((game) => {
          return {
            id: game.id,
            team: {
              logo: this.commonService.getImageStr(game.adversary.document.id),
              name: game.adversary.name,
            },
            points: game.pointsPerHit,
            prediction: null,
            result: {
              firstTeam: game.soccerTeamScore,
              secondTeam: game.adversaryScore,
            },
            winner: false,
            gameDate: game.gameDate,
            gameTime: game.gameTime?.slice(0, 5),
            canGuess:
              new Date(`${game.gameDate}T${game.gameTime}`) >
              new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
            championship: game.championship.title,
          };
        })
        .filter((game) => game.canGuess)
        .slice(0, count);
    });
  }

  getActiveSections() {
    this.activeSectionsService.getActiveSections().subscribe({
      next: (res: any) => {
        this.isBenefitsActive = res.sections?.parceiros || false;
        this.isActiveRanking = res.sections?.ranking || false;
        this.isActiveExperiences = res.sections?.experiencias || false;
        this.isActiveCheckins =
          (this.isSecondaryPlan ||
            (res.sections?.ingressos &&
              this.user?.memberSituation?.id ===
              this.memberSituationEnum.Adimplente)
          ) ||
          false;
      },
    });
  }

  getPartners() {
    forkJoin([
      this.couponService.getMemberCoupons(this.user.id),
      this.partnerService.getAllPartners()
    ]).subscribe(([couponsRes, partnersRes]: [any, any]) => {
      const coupons = couponsRes.slice(0, 3);
      coupons.forEach((coupon: any) => {
        coupon.partnerName = 'Cupom';
        coupon.src = this.carteirinhaImg;
        coupon.description = 'Cupom do Clube: ' + coupon.couponName;
      });

      const partner = partnersRes.content.slice(0, 3);
      partner.forEach((p: any) => {
        p.src = this.commonService.getImageStr(p.document.id);
      });

      this.partners = [...coupons, ...partner].slice(0, 3);
      console.log('Partners:', this.partners);
    });
  }

  getTrendClass(): string {
    if (!this.memberFinalScore || !this.memberFinalScore.trend) {
      return '';
    }
    switch (this.memberFinalScore.trend) {
      case 'up':
        return 'bi-caret-up-fill text-success';
      case 'down':
        return 'bi-caret-down-fill text-danger';
      case 'same':
        return 'bi-dash text-warning';
      default:
        return '';
    }
  }

  getMemberFinalScore() {
    this.memberFinalScoreService
      .getByMemberId(this.user.id)
      .subscribe((res: any) => {
        this.memberFinalScore = res;
      });
  }

  setHeight(event: any) {
    this.heightLastInvoice = event;
  }

  openModal(paymentType: PaymentType) {
    this.paymentInvoiceModalData = {
      invoiceId: this.lastInvoice.id,
      invoiceAmount: this.lastInvoice.amount,
      invoiceNumber: this.lastInvoice.id?.split('-')[0]
    };
    this.paymentType = paymentType;
    setTimeout(() => {
      this.modalService.open(this.modalId);
    }, 100);
  }

  goToPartnerData() {
    this.router.navigate(['/dados-de-socio']);
  }

  goToExperiences() {
    this.router.navigate(['/experiencias']);
  }

  onModalConfirm(event: any): void {
    console.log('onModalConfirm', event);
  }

  goToInvoiceDetail(invoice: any): void {
    // TODO: Mudar approach se o invoice obj for muito grande
    this.router.navigate(['/ver-fatura'], { state: { invoice: invoice } });
  }

  rankDetail(): void {
    this.router.navigate(['/ranking-de-socios']);
  }
  goToRescue(): void {
    this.router.navigate(['/resgates']);
  }

  showAllCoupons(): void {
    if (this.isCeara) {
      window.open('https://clubdevantagens.sociovozao.com/', '_blank');
    } else {
      this.router.navigate(['/parcerias']);
    }
  }

  getAddress() {
    if (this?.pattern?.addresses[0]) {
      let address = this?.pattern?.addresses[0];
      return `${address?.area},  ${address?.number != null ? address?.number : 'S/N'
        }, ${address?.complement}, ${address?.neighborhood}, ${address?.cityName
        } - ${address?.stateName},  CEP: ${this.cepPipe.transform(
          address?.zipCode
        )} `;
    } else {
      return '-';
    }
  }

  showTermsModal() {
    this.termsService.getTerms().subscribe((data) => {
      this.termsModalBodyMessage = data[0].content;
      this.modalService.open('termsModal');
    });
  }

  showModalpdateDataModal() {
    this.termsService.getTerms().subscribe((data) => {
      this.updateMemberModalBodyMessage = "Verificamos que o seu cadastro possui pendências nos dados e precisamos que o atualize para que continue navegando!";
      this.modalService.open('updateDataModal');
    });
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  onTermsModalConfirm() {
    this.memberService.setAcceptTerms(this.user.id).subscribe((res) => { });
  }

  hasQrCode() {
    return (this.user.memberSituation?.id == this.memberSituationEnum.Adimplente || this.isSecondaryPlan) &&
      this.memberShipCard != null && this.virtualCard == 'true';
  }

  showCarteirinha() {
    this.modalService.open('membershipCardModal');
  }

  get memberSituationEnum() {
    return MemberSituationEnum;
  }
}
